<template>
  <div
    ref="bg-ctn"
    class="bg-ctn"
  >
    <div
      v-if="backgroundTexts"
      data-depth="0.2"
      :class="[
        'bg-wrapper',
        `bg-wrapper--${selectedPreview}`,
        $store.state.isMobile ? undefined : 'bg-wrapper--no-transition'
      ]"
    >
      <div
        v-for="(text, index) in backgroundTexts"
        class="text-bg"
        :class="{'text-bg--visible' : index === selectedPreview}"
      >
        {{ text }}
      </div>
    </div>
    <div
      v-else
      data-depth="0.2"
      :class="[
        'bg-wrapper',
        `bg-wrapper--${selectedPreview}`,
        $store.state.isMobile ? undefined : 'bg-wrapper--no-transition'
      ]"
    >
      <slot />
    </div>
  </div>
</template>
<script>
import Parallax from 'parallax-js'

export default {
  name: 'Background',
  data () {
    return {
      parallax: undefined
    }
  },
  props: {
    selectedPreview: Number,
    backgroundTexts: Array
  },
  mounted () {
    if (!this.$store.state.isMobile) {
      let textBackground = this.$refs['bg-ctn']
      this.parallax = new Parallax(textBackground)
    }
  }
}
</script>
<style scoped lang="sass">
  @tailwind utilities

  /* purgecss start ignore */
  $transition: .7s

  .bg-ctn
    @apply h-full
    width: calc(100vw + 200px)
    position: fixed !important
    @screen sm-l
      width: calc(100vw + 300px)
    @screen md
      width: calc(100vw + 300px)
    @screen lg
      width: calc(100vw + 500px)

  .bg-wrapper
    $translate: $mobile-background-transition-distance
    width: inherit
    height: inherit
    transition: transform $transition
    @for $i from 1 through 5
      &--#{$i}
        transform: translateX(-$translate * $i)
    &--no-transition
      transition: none

  .text-bg
    @apply fixed pin-t pin-l font-sans opacity-0
    width: inherit
    font-size: 5.3rem
    line-height: 1
    transition: opacity $transition
    @screen lg
      transform: none
    &--visible
      @apply opacity-10
    @screen md
      font-size: 7.0rem
    @screen lg
      font-size: 8.3rem
    @screen xxl
      font-size: 10rem
    @screen xxxl
      font-size: 11rem

  /* purgecss end ignore */
</style>
